//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { NewsReaderProfileDisplayItem } from './NewsReaderProfileDisplayItem';
import { StudentStatus } from './Enums';

export class StudentProfileDisplayItem extends NewsReaderProfileDisplayItem {
    Active: boolean = false;
    Status: StudentStatus = StudentStatus.Active;
    CanRegisterCancelEvent: boolean = false;
    DateOfBirth: string | null = null;
    EmailRemindersEnabled: boolean = false;
    FaceTimeID: string | null = null;
    FamilyName: string | null = null;
    SkypeUsername: string | null = null;
    SubjectTypes: string[] = [];     // OBSOLETE - Use only for compatibility
    SMSRemindersEnabled: boolean = false;
    AdultStudentParentID: string | null = null;
    FamilyID: string | null = null;
    TeacherNames: string[] = [];
    Telephone: TelephoneInformationDisplayItem | null = null;

    constructor(initializer?: Partial<StudentProfileDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentProfileDisplayItem";
}
